export default "__VITE_ASSET__CcQEpANO__"